import { Link } from 'src/components';
import { FC, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTrackedClickHandler } from 'src/analytics/trackedClickHandler';
import { useEventClickAppStore } from 'src/analytics/useEventClickAppStore';
import { useExternalHref } from 'src/hooks/useExternalHref';
import { intlGetMessagesLocale } from 'src/utils/intl';
import { msgs } from './messages';
import * as S from './styles';

/**
 * Images for new languages you can find here:
 * https://developer.apple.com/app-store/marketing/guidelines/
 */

export const LinkToAppStore: FC = props => {
  const intl = useIntl();
  const messagesLocale = intlGetMessagesLocale(intl.locale);
  const [image, setImage] = useState('');

  const downloadFromAppStore = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    void (async () => {
      const module = await import(`./icons/download-on-the-app-store-badge-${messagesLocale}.svg`);
      setImage(module.default);
    })();
  }, [messagesLocale]);

  const eventClickAppStore = useEventClickAppStore('app-store');
  const trackedOnClick = useTrackedClickHandler(eventClickAppStore);

  const appStore = intl.formatMessage(msgs.appStore);
  const downloadFrom = intl.formatMessage(msgs.downloadFrom);
  const appStoreHref = useExternalHref({
    linkType: 'memrise-app-store',
  });

  return (
    <Link href={appStoreHref} passHref legacyBehavior>
      <S.AppStoreBadgeWrapper {...props} onClick={trackedOnClick} ref={downloadFromAppStore}>
        <S.AppStoreBadge $image={image} $locale={messagesLocale}>
          {downloadFrom} {appStore}
        </S.AppStoreBadge>
      </S.AppStoreBadgeWrapper>
    </Link>
  );
};

export default LinkToAppStore;
